import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';

import Article from '../../assets/icons/Article';
import Button from '../../components/Button/Button';
import TutorDashboardLayout from '../../components/TutorDashboardLayout/TutorDashboardLayout';
import { getTeacherTopics } from '../../services/learnService';
import LearnSubjectCard from '../../components/LearnSubjectCard/LearnSubjectCard';
import Spinner from '../../components/Spinner/Spinner';
import * as services from '../../services/learnService';
import { notification } from 'antd';

const TutorDashboard = () => {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  let userData = JSON.parse(localStorage.getItem('userData'));
  let school = JSON.parse(localStorage.getItem('school'));
  let name = school ? school.name : '';

  const getCourses = async () => {
    try {
      setLoading(true);
      let res = await getTeacherTopics();
      setCourses(res?.data?.topics);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, []);

  const viewLesson = (id) => {
    navigate(`/tutor/courses/${id}`);
  };

  const publish = async (course, el) => {
    localStorage.setItem('course', JSON.stringify(course));
    localStorage.setItem('topic', JSON.stringify(el));

    try {
      setLoading(true);
      await services.publishCourse();
      services.publishTopic();
      let token = localStorage.getItem('token');
      let userData = JSON.parse(localStorage.getItem('userData'));
      localStorage.clear();
      localStorage.setItem('token', token);
      localStorage.setItem('userData', JSON.stringify(userData));
      notification['success']({
        message: 'Course Published Successfully',
      });
      notification['success']({
        message: 'Topic Published Successfully',
      });
      setLoading(false);
      getCourses();
    } catch (error) {
      setLoading(false);
      console.log(error);
      notification['error']({
        message: 'An error occured,please try again',
      });
    }
  };

  const deleteCourse = async (id) => {
    try {
      let res1 = await services.deleteCourse(id);
      notification['success']({
        message: 'Course deleted successfully',
      });
      setLoading(false);
      getCourses();
    } catch (error) {
      setLoading(false);
      notification['error']({
        message: error?.response?.data?.message,
      });
    }
  };

  return (
    <TutorDashboardLayout>
      <div style={{ display: 'flex' }}>
        <div className='tutor-dashboard'>
          <div
            className='tutor-dashboard__left'
            style={{ display: 'flex', width: '80%' }}
          >
            <div className='tutor-dashboard__left__first-card'>
              <h2 className='tutor-dashboard__left__first-card__title'>
                Hello {userData?.first_name || name} ,
              </h2>
              <p className='tutor-dashboard__left__first-card__subtitle'>
                Welcome back! Start creating lessons easily and schedule live
                classes with your students right here on your PL by Edves
                dashboard
              </p>
            </div>

            {loading ? (
              <Spinner />
            ) : courses?.length === 0 ? (
              <div className='tutor-dashboard__left__second-card'>
                <Article />
                <h2 className='tutor-dashboard__left__second-card__title'>
                  No lesson
                </h2>
                <p className='tutor-dashboard__left__second-card__subtitle'>
                  You have not created any lesson yet, once you create and{' '}
                  <br /> publish a lesson. All your published lessons will
                  appear here.
                </p>
                <div className='tutor-dashboard__left__second-card__btn'>
                  <button onClick={() => navigate('/add-lesson')}>
                    Create Lesson
                  </button>
                </div>
              </div>
            ) : (
              <div
                style={{ marginTop: '60px', width: '892px' }}
                className='tutor-dashboard__left__second-card-filled'
              >
                {courses === 0 ? (
                  <div>No subjects found </div>
                ) : (
                  <div>
                    <div className='courses-heading'>
                      <h2>Your Lessons</h2>
                      <Button
                        text={'View All Lessons'}
                        className='primary-btn'
                        onClick={() => navigate('/tutor/courses')}
                      />
                    </div>
                    <div className='dashboard-courses'>
                      {courses?.slice(0, 2)?.map((el, index) => (
                        <LearnSubjectCard
                          schoolHeader={
                            school?.id === 15
                              ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1686242278/resize-1686242256868457235parentingcourse_qwjsox.jpg'
                              : school?.id === 12
                              ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680096219/WhatsApp_Image_2023-03-29_at_13.50.08_hqqdcv.jpg'
                              : el?.course?.subject_class?.title
                                  ?.toLowerCase()
                                  ?.includes('biology')
                              ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833246/4_ywa1uq.jpg'
                              : el?.course?.subject_class?.title
                                  ?.toLowerCase()
                                  ?.includes('mathematics')
                              ? 'https://leverageedu.com/blog/wp-content/uploads/2020/07/Branches-of-Mathematics.png'
                              : el?.course?.subject_class?.title
                                  ?.toLowerCase()
                                  ?.includes('english')
                              ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRrP9mK3dTuXB86woJ2JW7J8TkxszYhRVk_4Q&usqp=CAU'
                              : el?.course?.subject_class?.title
                                  ?.toLowerCase()
                                  .includes('food')
                              ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1680783147/food_and_nutrition_lqxah9.png'
                              : el?.course?.subject_class?.title
                                  ?.toLowerCase()
                                  .includes('economics')
                              ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833433/9_eknlh0.jpg'
                              : el?.course?.subject_class?.title
                                  ?.toLowerCase()
                                  .includes('technical')
                              ? 'https://res.cloudinary.com/dzpqw6eo3/image/upload/v1683833564/3_tzp8za.jpg'
                              : el.banner
                          }
                          el={el}
                          course={el.course}
                          id={el.id}
                          topic={el?.course?.subject_class?.title}
                          published={el.published}
                          type={el.course.lesson_style}
                          tutor
                          description={el.title}
                          lesson_count={el.lessons_count}
                          viewLesson={viewLesson}
                          publishCourse={publish}
                          deleteCourse={deleteCourse}
                          index={index}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* <div
              className='tutor-dashboard__left__second-card'
              style={{ height: '284px' }}
            >
              <Article />
              <h2 className='tutor-dashboard__left__second-card__title'>
                No enrolled student
              </h2>
              <p className='tutor-dashboard__left__second-card__subtitle'>
                Once you publish your lessons. Come here to see a summary of
                students who has enrolled
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </TutorDashboardLayout>
  );
};

export default TutorDashboard;
